import React, { useState } from 'react'
import Style from './Register.module.css'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { paths } from '../../utils/routes';


export default function Register() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigator = useNavigate();
  const initialValues = {
    name: '',
    email: '',
    password: '',
    rePassword: '',
    phone: '',
  };


  const register = async (user) => {
    setIsLoading(true);
    try {
      const { data } = await axios.post('https://ecommerce.routemisr.com/api/v1/auth/signup', user);
      setIsLoading(false);
      navigator(paths.login)
    } catch ({ response }) {
      if (!response.data.message) {
        setError('Something went wrong!');
      }
      setError(response.data.message);
      setIsLoading(false);

    }
  }

  const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/




  let validationSchema = Yup.object({
    name: Yup.string().min(3, 'Minimum length is 3').max(10, 'Maximum length is 10').required('Name is required'),
    email: Yup.string().email('Email is Invalid').required('Email is required'),
    password: Yup.string().matches(/^[A-Z][a-z0-9]{5,10}$/, 'Password is Invalid').required('Password is required'),
    rePassword: Yup.string().oneOf([Yup.ref('password')], 'Password Doesn\'t Match').required('Re-Password is required'),
    phone: Yup.string().matches(phoneRegExp, 'Phone is Invalid').required('Phone is required'),
  })

  // const validate = (values) => {
  //   let errors = {};
  //   if (!values.name) {
  //     errors.name = 'Name is required';
  //   }
  //   if (!values.email) {
  //     errors.email = 'Email is required';
  //   } if (!values.password) {
  //     errors.password = 'Email is required';
  //   } if (!values.rePassword) {
  //     errors.rePassword = 'Email is required';
  //   }
  //   console.log(errors);
  //   return errors
  // }
  let formik = useFormik({
    initialValues: initialValues,
    validationSchema,
    onSubmit: register,

  })

  return (
    <div className="w-75 mx-auto py-4">
      <h3 className='my-3'>Register Now</h3>
      {error && <p className='alert alert-danger'>{error}</p>}
      <form onSubmit={formik.handleSubmit}>

        <label htmlFor="name" className='my-2'> Name</label>
        <input id='name' name='name' type="text" value={formik.values.name} className='form-control' onChange={formik.handleChange} onBlur={formik.handleBlur} />
        {formik.touched.name && formik.errors.name && <p className='alert alert-danger my-2'>{formik.errors.name}</p>}

        <label htmlFor="email" className='my-2'> Email</label>
        <input id='email' name='email' type="email" value={formik.values.email} className='form-control' onChange={formik.handleChange} onBlur={formik.handleBlur} />
        {formik.touched.email && formik.errors.email && <p className='alert alert-danger my-2'>{formik.errors.email}</p>}

        <label htmlFor="password" className='my-2'> Password</label>
        <input id='password' name='password' type="password" value={formik.values.password} className='form-control' onChange={formik.handleChange} onBlur={formik.handleBlur} />
        {formik.touched.password && formik.errors.password && <p className='alert alert-danger my-2'>{formik.errors.password}</p>}

        <label htmlFor="rePassword" className='my-2'> Re-Password</label>
        <input id='rePassword' name='rePassword' type="password" value={formik.values.rePassword} className='form-control' onChange={formik.handleChange} onBlur={formik.handleBlur} />
        {formik.touched.rePassword && formik.errors.rePassword && <p className='alert alert-danger my-2'>{formik.errors.rePassword}</p>}

        <label htmlFor="phone" className='my-2'> Phone</label>
        <input id='phone' name='phone' type="tel" value={formik.values.phone} className='form-control' onChange={formik.handleChange} onBlur={formik.handleBlur} />
        {formik.touched.phone && formik.errors.phone && <p className='alert alert-danger my-2'>{formik.errors.phone}</p>}

        <button type='submit' className='btn btn-success my-3' disabled={!(formik.isValid && formik.dirty)} >{isLoading ? <i className="fa-solid fa-spinner fa-spin"></i> : 'Resgister'}</button>
      </form>
    </div>
  )
}
